module.exports = "/assets/b520b8763f376a2f5d49707879758704.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/travelodge-icon.png
// module id = 612
// module chunks = 0